import { Dialog, Grid, Link, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

import { useDashboardStyles } from './Dashboard.styles'
import { useGlobalStyles } from '~shared/styles/globalStyles'
import ScreenContainerMain from '~shared/components/ScreenContainerMain'
import RoundedButton from '~shared/components/StyledButton/RoundedButton'
import ShoppingCartOutlined from '@mui/icons-material/ShoppingCartOutlined'
import PlayCircleFilled from '@mui/icons-material/PlayCircleFilled'
import IconHeadSnowflake from '~shared/components/icons/IconHeadSnowflake'
import IconHammerScrewdriver from '~shared/components/icons/IconHammerScrewdriver'
import PersonAdd from '@mui/icons-material/PersonAdd'

const Dashboard: React.FC = () => {
  const gs = useGlobalStyles()
  const s = useDashboardStyles()
  const { t } = useTranslation()
  const history = useHistory()
  const theme = useTheme()
  const isTabletLarge = useMediaQuery(theme.breakpoints.down('md'))
  const isTablet = useMediaQuery(theme.breakpoints.down('sm'))
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))

  // const [openDialog, setOpenDialog] = useState(true)

  const navigate = useCallback((routeName: string) => () => {
    history.push(routeName)
  }, [history])

  return <ScreenContainerMain>
    {/* <Dialog open={openDialog}> */}
    {/*  <div style={{ padding: '20px' }}> */}
    {/*    <Typography className={gs.marginBottomSmall}> */}
    {/*      {t('common:infoNetworkProblems1')} */}
    {/*      <Link href={t('common:infoNetworkProblemsLink')} target='_blank'>safholland.com</Link>. */}
    {/*      <br /> */}
    {/*      <br /> */}
    {/*      {t('common:infoNetworkProblems2')} */}
    {/*    </Typography> */}
    {/*    <RoundedButton color='secondary' onClick={() => { setOpenDialog(false) }}> */}
    {/*      {t('form:close')} */}
    {/*    </RoundedButton> */}
    {/*  </div> */}
    {/* </Dialog> */}
    <Typography variant='h2' component='h1' className={gs.marginBottomMedium}>
      {t('common:dashboardTextHeadline')}
    </Typography>
    <Grid container spacing={3}>
      <Grid item sm={12} md={6}>
        <Typography variant='h4' className={gs.marginBottomSmall}>{t('common:dashboardPageHeadline')}</Typography>
        <Typography className={gs.marginBottomSmall}>{t('common:dashboardText1')}</Typography>
        <Typography className={gs.marginBottomSmall}>{t('common:dashboardText2')}</Typography>
        <Typography className={gs.marginBottomSmall}>{t('common:dashboardText3')}</Typography>
      </Grid>
      <Grid item sm={12} md={6}>
        <div className={s.cardContainer}>
          <RoundedButton endIcon={<ShoppingCartOutlined />} onClick={navigate('/pod')}>
            {t('common:partsOnDemand')}
          </RoundedButton>
          <RoundedButton endIcon={<IconHammerScrewdriver width='26px' color='#FFFFFF' />} onClick={navigate('/serviceReportOnline')}>
            {t('common:reklamation')}
          </RoundedButton>
          <RoundedButton endIcon={<IconHeadSnowflake width='26px' color='#FFFFFF' />} onClick={navigate('/empolis')}>
            {t('common:knowledgePortal')}
          </RoundedButton>
          {/* <RoundedButton endIcon={<PlayCircleFilled />} onClick={navigate('/academy')}> */}
          {/*  {t('common:navLabelAcademy')} */}
          {/* </RoundedButton> */}
          <RoundedButton color='secondary' endIcon={<PersonAdd />} onClick={navigate('/inviteColleagues')}>
            {t('common:inviteColleague')}
          </RoundedButton>
        </div>
      </Grid>
    </Grid>
  </ScreenContainerMain>
}

export default Dashboard
